import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';

const DateFilter = ({ selectedDate, handleDateChange, toggleDatePicker, label }) => {
    const handleClick = () => {
        if (toggleDatePicker) {
            toggleDatePicker(`${label.toLowerCase()}-datepicker`);
        }
    };

    const handleKeyDown = (e) => {
        if ((e.key === 'Enter' || e.key === ' ') && toggleDatePicker) {
            e.preventDefault();
            toggleDatePicker(`${label.toLowerCase()}-datepicker`);
        }
    };

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    return (
        <div className="filter-item">
            <label htmlFor={`${label.toLowerCase()}-datepicker`}>{label}:</label>
            <DatePicker
                id={`${label.toLowerCase()}-datepicker`}
                selected={selectedDate}
                onChange={handleDateChange}
                dateFormat="yyyy-MM-dd"
                calendarStartDay={1}
                showPopperArrow={false}
                popperPlacement="bottom-start"
                maxDate={tomorrow}
                popperModifiers={{
                    offset: {
                        enabled: true,
                        offset: '5px, 10px'
                    },
                    preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                        boundariesElement: 'viewport'
                    }
                }}
                ariaLabel={`Select ${label} date`}
                ariaDescribedBy={`${label.toLowerCase()}-description`}
            />
            <span 
                className="filter-icon" 
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                role="button"
                tabIndex={0}
                aria-label={`Open ${label} date picker`}
            >
                <FontAwesomeIcon
                    icon={faCalendar}
                    aria-hidden="true"
                />
            </span>
            <span id={`${label.toLowerCase()}-description`} className="sr-only">
                Use arrow keys to navigate dates in the calendar
            </span>
        </div>
    );
};

DateFilter.propTypes = {
    selectedDate: PropTypes.instanceOf(Date),
    handleDateChange: PropTypes.func.isRequired,
    toggleDatePicker: PropTypes.func,
    label: PropTypes.string.isRequired,
};

export default DateFilter;
